import { render, staticRenderFns } from "./Accreditations.vue?vue&type=template&id=70e5df0b&scoped=true&"
import script from "./Accreditations.vue?vue&type=script&lang=js&"
export * from "./Accreditations.vue?vue&type=script&lang=js&"
import style0 from "./Accreditations.vue?vue&type=style&index=0&id=70e5df0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5df0b",
  null
  
)

export default component.exports